<template>
  <div class="page-container">
    <h2 class="name">MIS Report</h2>

    <!-- Top Edit MIS Bill Section -->
    <div class="top-edit-section">
      <!-- Left Side for Edit MIS Bill -->
      <div class="left-side">
        <!-- Form Fields -->
        <div class="row first-row">
          <div class="field">
            <label for="date">Date:</label>
            <input v-model="date" type="date" id="date" class="input-box" />
          </div>
          <div class="field">
            <label for="applicant">Applicant:</label>
            <v-select v-model="selectedApplicant" :options="applicants" label="applicantname"
              :reduce="applicant => applicant.applicantid" placeholder="Select Applicant" class="input-box"
              :clearable="false" selectOnTab="True" />
          </div>
          <div class="field">
            <label for="account">Account:</label>
            <v-select v-model="selectedAccount" :options="accounts" label="accountname"
              :reduce="account => account.accountid" placeholder="Select Account" class="input-box" :clearable="false"
              selectOnTab="True" />
          </div>
        </div>

        <div class="row second-row">
          <div class="field">
            <label for="customer-ref">Customer Ref NO:</label>
            <input v-model="customerRef" type="text" id="customer-ref" class="input-box" />
          </div>
          <div class="field checkbox-field center-checkbox">
            <label for="report-in-bill">Report in BILL:</label>
            <input v-model="reportInBill"  type="checkbox" id="report-in-bill" />
          </div>
          <div class="field">
            <label for="report-date">Report Date:</label>
            <input v-model="reportDate" type="date" id="report-date" class="input-box" />
          </div>
          <div class="field checkbox-field center-checkbox">
            <label for="round-off-checkbox">Round Off:</label>
            <input v-model="roundOffChecked" type="checkbox" id="round-off-checkbox" />
          </div>
        </div>
        <div class="">
          <label for="particulars">Particulars:</label>
          <!--<QuillEditor theme="snow" toolbar="essential" v-model:content="particulars" content-type="html" />-->
          <textarea v-model="particulars" ref="myTextarea" id="particulars" @keyup.enter="handleEnter" class="particulars-box"></textarea>
        </div>
        <hr class="separator" />

        <div class="row non-gst-row">
          <div class="field checkbox-field center-checkbox center-non">
            <label for="non-gst-bill">Non-GST Bill:</label>
            <input v-model="nonGstBill" type="checkbox" id="non-gst-bill" />
            <label for="exp-bill">Exp Bill:</label>
            <input v-model="isExpBill" type="checkbox" id="exp-bill" />
          </div>
        </div>

        <!-- Product Details Table -->
        <div class="table-section">
          <h4>Product Details</h4>
          <table class="details-table">
            <thead>
              <tr>
                <th>Product Description</th>
                <th>Quantity</th>
                <th>Unit</th>
                <th>Rate</th>
                <th>Amount</th>
                <th>CGST</th>
                <th>SGST</th>
                <th>IGST</th>
                <th>Item Total</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in productDetails" :key="index">
                <td>
                  <select id="prodesc" v-model="item.productDescription" class="custom-select">
                    <option value="0">Select Product</option>
                    <option v-for="product in productOptions" :key="product.value" :value="product.value">
                      {{ product.description }}
                    </option>
                  </select>
                </td>
                <td><input v-model.number="item.quantity" type="number" class="input-box" /></td>
                <td><input v-model="item.unit" type="text" class="input-box" /></td>
                <td><input v-model.number="item.rate" type="number" class="input-box" @keydown.tab="addRow(item,index)"
                    @keyup.enter="addRow(item,index)" />
                </td>
                <td><input v-model.number="item.amount" type="text" readonly class="onlyread" /></td>
                <td><input v-model.number="item.cgst" type="text" readonly class="onlyread" /></td>
                <td><input v-model.number="item.sgst" type="text" readonly class="onlyread" /></td>
                <td><input v-model.number="item.igst" type="text" readonly class="onlyread" /></td>
                <td>{{ formatToTwoDecimal(calculateItemTotal(item)) }}</td>
                <td>
                  <button v-if="productDetails.length > 1" @click="removeRow(index)" class="delete-btn">
                    ✖
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Amount Summary Table -->
        <div class="table-section">
          <h4>Amount Summary</h4>
          <table class="summary-table">
            <thead>
              <tr>
                <th>Amount</th>
                <th>CGST</th>
                <th>SGST</th>
                <th>IGST</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ formatToTwoDecimal(totalAmount) }}</td>
                <td>{{ formatToTwoDecimal(totalCGST) }}</td>
                <td>{{ formatToTwoDecimal(totalSGST) }}</td>
                <td>{{ formatToTwoDecimal(totalIGST) }}</td>
                <td>{{ formatToTwoDecimal(totalSummary) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Final Details -->
        <div class="row final-row">
          <div class="field">
            <label for="round-off-amount">Round Off:</label>
            <div id="round-off-amount" class="readonly-value">{{ formatToTwoDecimal(roundOffAmount) }}</div>
          </div>
          <div class="field">
            <label for="payable-amount">Payable Amount:</label>
            <div id="payable-amount" class="readonly-value">{{ formatToTwoDecimal(payableAmount) }}</div>
          </div>
        </div>

        <!-- Save Button -->
        <div class="save-button">
          <button @click="saveReport" :disabled="isSubmitting">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
//import { QuillEditor } from '@vueup/vue-quill'
//import '@vueup/vue-quill/dist/vue-quill.snow.css'
//import '@vueup/vue-quill/dist/vue-quill.bubble.css';


export default {
  components: {
    vSelect,
    //QuillEditor
  },
  data() {
    //return { modules }
    return {
      date: this.getCurrentDate(),
      selectedApplicant: null,
      selectedAccount: null,
      customerRef: '',
      reportInBill: false,
      particulars: '',
      reportDate: '',
      taxslab: 1,
      roundOffChecked: false, // Add this
      rndval: 0,
      payableamt: 0,
      nonGstBill: false,
      isExpBill: false,
      productDetails: [{ productDescription: 'Survey Fees', quantity: 0, unit: 'Cntr', rate: 0, amount: 0, sgst: 0, cgst: 0, igst: 0 }],
      productOptions: [
        { description: 'Survey Fees', value: 'Survey Fees' },
        { description: 'Travelling', value: 'Travelling' },
        { description: 'Misc Expenses', value: 'Misc Expenses' }
      ],
      accounts: JSON.parse(localStorage.getItem('accounts') || '[]'),
      applicants: JSON.parse(localStorage.getItem('applicants') || '[]'),
      MisDbList: [],
      MisDbListDtl: [],
      usercompany: [],
      isSubmitting: false,
      content: "<h1>Some initial content</h1>"
    };
  },
  computed: {
    totalAmount() {
      return this.productDetails.reduce((sum, item) => sum + this.calculateAmount(item), 0);
    },
    totalCGST() {
      return this.productDetails.reduce((sum, item) => sum + item.cgst, 0);
    },
    totalSGST() {

      return this.productDetails.reduce((sum, item) => sum + item.sgst, 0);
    },
    totalIGST() {
      return this.productDetails.reduce((sum, item) => sum + item.igst, 0);
    },
    totalSummary() {
      return this.totalAmount + this.totalCGST + this.totalSGST + this.totalIGST;
    },
    payableAmount() {
      let amount = this.totalSummary;
      if (this.roundOffChecked) {
        amount = Math.round(amount);
      }
      return amount;
    },
    roundOffAmount() {
      let rndamount = 0
      let amount = this.totalSummary;
      if (this.roundOffChecked) {
        let roundedamt = Math.round(amount);
        rndamount = amount - roundedamt
      }
      return rndamount;
    }
  },
  methods: {
    handleEnter() {
      const cursorPosition = this.$refs.myTextarea.selectionStart;
      const start = this.particulars.substring(0, cursorPosition);
      const end = this.particulars.substring(cursorPosition);
      this.particulars = start + '<br>' + end;
    },
    //inChangeReportInBill(event) {
    //  this.reportDate = event.target.checked ? this.getCurrentDate() : '';
    //},
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const day = String(today.getDate()).padStart(2, '0');
      //return `${day}/${month}/${year}`;
      return `${year}-${month}-${day}`;
    },
    resetentry() {
      this.date = this.getCurrentDate();
      this.selectedApplicant = null;
      this.selectedAccount = null;
      this.customerRef = '';
      this.reportInBill = false;
      this.particulars = '';
      this.reportDate = '';
      this.taxslab = 1;
      this.roundOffChecked = false; // Add this
      this.rndval = 0;
      this.payableamt = 0;
      this.nonGstBill = false;
      this.isExpBill = false;
      this.productDetails = [{ productDescription: '', quantity: 0, unit: '', rate: 0, amount: 0, sgst: 0, cgst: 0, igst: 0 }];
      this.MisDbList = [];
      this.MisDbListDtl = [];
      this.content = ""
    },
    async saveReport() {
      if (this.isSubmitting) return;
      
      if (!this.selectedApplicant) {
        useToast().error('Please select an applicant');
        return;
      }
      if (!this.date) {
        useToast().error('Please select a date');
        return;
      }
      if (this.reportInBill == true && !this.reportDate) {
        useToast().error('Please select a report date');
        return;
      }
      if (this.MisDbListDtl.length == 0) {
        useToast().error('Please add at least one product detail');
        return;
      }
      
      this.isSubmitting = true;
      
      try {
        // Add your save logic here
        //console.log('Report saved');
        this.MisDbList = [];
        const selectedParty = this.applicants.find(app => app.applicantid === Number(this.selectedApplicant));
        const misMast = {
          applicantID: this.selectedApplicant,
          accountID: this.selectedAccount,
          state_id: selectedParty.state_id,
          billdate: this.date,
          custrefno: this.customerRef,
          isReport: this.reportInBill,
          reportdate: this.reportInBill == false ? null : this.reportDate,
          isRound: this.roundOffChecked,
          rndval: this.roundOffAmount,
          payableamt: this.payableAmount,
          nonGstBill: this.nonGstBill,
          particulars: this.particulars,
          taxslab: this.taxslab,
          isExpBill: this.isExpBill,
        };
        //console.log(this.particulars)
        this.MisDbList.push(misMast);
        const mismaster = JSON.stringify(this.MisDbList)
        //console.log(mismaster);

        const misdtls = JSON.stringify(this.MisDbListDtl)
        //console.log(misdtls);
        const data = new FormData();
        data.append('mismaster', mismaster)
        data.append('misdetail', misdtls)
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`, // Include the token in the headers
          },
        };
        const response = await axios.post('/savemisbill', data, config);
        //console.log(response);
        if (response.data[0] === 0) {
          // Display success message using the second element of the response
          useToast().error(response.data[1]);
        } else {
          useToast().success('Created Succesful');
          this.resetentry();
          this.printreport(response.data[2]);
          //console.log(this.successfulTasks, 'hello')
        }
      } catch (error) {
        console.error('Error saving report:', error);
        useToast().error(error.response?.data?.message || 'Error saving report. Please try again.');
      } finally {
        this.isSubmitting = false;
      }
    },
    async printreport(filename) {
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        const urlpath = `/printmispdf?filename=${filename}`;
        //console.log(urlpath)
        const response = await axios.get(urlpath, config);
        //console.log(response);
        const pdfBlob = new Blob([response.data], filename, { type: "application/pdf" });
        const url = URL.createObjectURL(pdfBlob);
        window.open(url);
      } catch (error) {
        console.error('Error generating report:', error);
        useToast().error(error.response?.data?.message || 'Error printing report.');
      }
    },
    calculateAmount(item) {
      return item.quantity * item.rate;
    },
    calculateItemTotal(item) {
      return item.amount + item.cgst + item.sgst + item.igst;
    },
    calculateAllAmount(item) {
      //console.log(this.usercompany);
      const selectedParty = this.applicants.find(app => app.applicantid === Number(this.selectedApplicant));
      //console.log(selectedParty)
      //console.log(selectedParty.state_id)
      item.amount = item.quantity * item.rate;
      item.igst = 0
      item.sgst = 0
      item.cgst = 0
      if (this.nonGstBill == false) {
        if (this.usercompany.state_id == selectedParty.state_id) {
          this.taxslab = 2
          item.cgst = Number(this.formatToTwoDecimal(item.amount * 0.09));
          item.sgst = Number(this.formatToTwoDecimal(item.amount * 0.09));
        } else {
          this.taxslab = 1
          item.igst = Number(this.formatToTwoDecimal(item.amount * 0.18));
        }
      }
    },
    addRow(item,index) {
      //console.log(item);
      if (item.productDescription == 0 || item.productDescription == '' || item.productDescription == null || item.quantity == 0 || item.rate == 0) {
        return;
      }
      this.calculateAllAmount(item)
      const misDtl = {
        billitem: item.productDescription,
        qty: item.quantity,
        unit: item.unit,
        rate: item.rate,
        amount: item.amount,
        cgst: item.cgst,
        sgst: item.sgst,
        igst: item.igst
      };

      //const index = this.MisDbListDtl.findIndex(misDtls => misDtls.billitem === misDtl.billitem)
      //console.log(index);
      //if (index !== -1) {
      //  this.MisDbListDtl.splice(index, 1, misDtl);
      //} else {
      //  this.MisDbListDtl.push(misDtl);
      //}
      this.MisDbListDtl.splice(index, 1);
      this.MisDbListDtl.push(misDtl);
      this.productDetails.push({ productDescription: 0, quantity: 0, unit: '', rate: 0, amount: 0, sgst: 0, cgst: 0, igst: 0 });
      //document.getElementById('prodesc').focus();
    },
    removeRow(index) {
      if (this.productDetails.length > 1) {
        this.productDetails.splice(index, 1);
        this.MisDbListDtl.splice(index, 1);
      }
    },
    formatToTwoDecimal(value) {
      return value.toFixed(2);
    }
  }, created() {
    this.usercompany = JSON.parse(localStorage.getItem('user'));
  }
};
</script>

<style scoped>
.ql-container ql-snow {
  background: white;
  height: 200px;
}

.page-container {
  margin-left: 20px;
  /* Adjust as needed */
}

.name {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.top-edit-section {
  border: 1px solid #ddd;
  padding: 20px;
}

.row {
  display: flex;
  margin-bottom: 10px;
}

.field {
  margin-right: 20px;
  flex: 1;
}

.first-row .field,
.second-row .field {
  flex: 1;
}

.checkbox-field {
  display: flex;
  align-items: center;
}

.center-checkbox {
  text-align: center;
  flex: 1;
}

.input-box,
.particulars-box {
  width: 100%;
}

.particulars-box {
  min-height: 100px;
}

.separator {
  margin: 20px 0;
}

.table-section {
  margin-top: 20px;
}

.details-table,
.summary-table {
  width: 100%;
  border-collapse: collapse;
}

.center-non {
  margin-left: 45%;
}

.details-table th,
.details-table td,
.summary-table th,
.summary-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.delete-btn {
  background: none;
  border: none;
  color: red;
  cursor: pointer;
}

.readonly-value {
  font-weight: bold;
}

.save-button {
  margin-top: 20px;
  text-align: center;
}

.save-button button {
  padding: 10px 20px;
  font-size: 16px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.save-button button:hover {
  background-color: #0056b3;
}

.save-button button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Additional styles for proper alignment */
.final-row {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  /* Align the fields vertically */
  align-items: flex-end;
  /* Align fields to the right side */
  gap: 20px;
  /* Space between fields */
}

.field {
  display: flex;
  flex-direction: row;
  /* Align label and value horizontally */
  align-items: center;
  /* Center items vertically */
}

.field label {
  margin-right: 10px;
  /* Space between label and value */
}

.readonly-value {
  font-size: 16px;
  /* Adjust font size as needed */
  font-weight: bold;
  /* Optional: Make the value bold */
}

.onlyread {
  width: 100px;
  background: transparent;
}
</style>
